import { render, staticRenderFns } from "./ViewOrganizationTasks.vue?vue&type=template&id=4281d187"
import script from "./ViewOrganizationTasks.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports